// Tailwind-ramp pairs matching the app's pill palette: light bg, strong
// fg (used for border + initials). Order matters — it's the hash space.
const AVATAR_COLORS = [
  { bg: "#EEF2FF", fg: "#4F46E5" }, // indigo
  { bg: "#DBEAFE", fg: "#1E40AF" }, // blue
  { bg: "#DCFCE7", fg: "#16A34A" }, // green
  { bg: "#FEF3C7", fg: "#A16207" }, // amber
  { bg: "#FFEDD5", fg: "#C2410C" }, // orange
  { bg: "#FCE7F3", fg: "#BE185D" }, // pink
  { bg: "#F3E8FF", fg: "#7E22CE" }, // purple
  { bg: "#CCFBF1", fg: "#0F766E" }, // teal
];

// Deterministic per-person avatar color: hash the name (fallback seed)
// into the palette, so the same DB always renders the same color with
// no stored mapping.
export const getAvatarColors = (seed) => {
  const s = String(seed || "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) % 2147483647;
  }
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

export const getInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "DB";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

export const formatPingAge = (ageSec) => {
  if (ageSec === null || ageSec === undefined) return "no recent ping";
  if (ageSec < 10) return "ping just now";
  if (ageSec < 60) return `ping ${Math.round(ageSec)}s ago`;
  if (ageSec < 3600) return `ping ${Math.round(ageSec / 60)}m ago`;
  return `ping ${Math.round(ageSec / 3600)}h ago`;
};

export const formatUpdatedAt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `updated ${hh}:${mm}`;
};
